/**
 * 日期工具函数
 */

/**
 * 格式化为 YYYY-MM-DD
 */
export function formatDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * 解析 YYYY-MM-DD 为 Date
 */
export function parseDate(s: string): Date {
  const parts = s.split('-');
  return new Date(
    parseInt(parts[0]!, 10),
    parseInt(parts[1]!, 10) - 1,
    parseInt(parts[2]!, 10),
  );
}

/**
 * 获取某月的所有日期（用于月视图渲染）
 * 包含上个月末尾、当月、下个月开头，补齐 6 周共 42 天
 * @param yearMonth YYYY-MM
 * @param weekStart 0=周日开始, 1=周一开始
 */
export function getCalendarDays(yearMonth: string, weekStart: 0 | 1 = 1): Date[] {
  const parts = yearMonth.split('-');
  const year = parseInt(parts[0]!, 10);
  const month = parseInt(parts[1]!, 10) - 1; // 0-based

  const firstDay = new Date(year, month, 1);
  const firstDayOfWeek = firstDay.getDay(); // 0=Sun, 1=Mon, ...

  // 计算第一格应该是几号
  let offset = firstDayOfWeek - weekStart;
  if (offset < 0) offset += 7;

  const startDate = new Date(year, month, 1 - offset);
  const days: Date[] = [];
  for (let i = 0; i < 42; i++) {
    days.push(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i));
  }
  return days;
}

/**
 * 判断两个日期是否同一天
 */
export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/**
 * 获取今天的 YYYY-MM-DD
 */
export function today(): string {
  return formatDate(new Date());
}

/**
 * 计算 ISO 周数
 */
export function getISOWeek(d: Date): number {
  const target = new Date(d.valueOf());
  const dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
  }
  return 1 + Math.ceil((firstThursday - target.valueOf()) / 604800000);
}
